// extracted by mini-css-extract-plugin
export default {"otpContainer":"auth_otpContainer__3GZkZ","otpInput":"auth_otpInput__v9++E","otpLabel":"auth_otpLabel__4gfE0"};